import { createContext, useContext } from 'react';
export const SearchableMenuContext = createContext({});
export function useSearchableMenu() {
    return useContext(SearchableMenuContext);
}
